module.exports = __webpack_public_path__ + "static/mobileheader-aa3e0f6c0880c7195d781f84214ecccc.mp4";